
import React from "react";
import { useOnboardingState } from "@/integrations/supabase/onboarding";
import { useAuth } from "@/hooks/useAuth";
import { Link } from "react-router-dom";

const progressSteps = [
  "Twilio",
  "Number",
  "Forward",
  "Recording",
  "DNI"
];

export function OnboardingBanner() {
  const { onboarding } = useOnboardingState();
  const { user, isAgency, isBusinessOwner } = useAuth();
  
  // Get user role from auth metadata
  const userRole = user?.app_metadata?.role || 'agent';
  
  // Only Owner and Manager can see the banner by default
  // Supervisor can see it only if wizard already started
  const canViewBanner = ['owner', 'manager'].includes(userRole) || 
    (userRole === 'supervisor' && onboarding?.onboarding_started_at);
  
  // Don't show banner if onboarding is completed or user doesn't have permission
  if (!onboarding || onboarding.status === "completed" || !canViewBanner) return null;

  const currentStep = progressSteps.findIndex(
    step => step.toLowerCase() === onboarding.current_step
  );
  
  return (
    <div className="bg-yellow-50 border-b border-yellow-300 text-yellow-900 p-3 flex justify-between items-center">
      <div>
        <span>Complete onboarding: </span>
        {progressSteps.map((step, idx) => (
          <span
            key={idx}
            className={
              idx === currentStep
                ? "font-bold underline"
                : idx < currentStep
                  ? "text-green-700"
                  : "text-gray-400"
            }
          >
            {step}{idx < progressSteps.length - 1 && " > "}
          </span>
        ))}
        
        {/* Role-specific guidance */}
        {currentStep === 0 && (
          <span className="ml-2 text-xs bg-yellow-100 px-2 py-1 rounded">
            {isAgency() ? "Connect your Twilio account" : "We'll create a Twilio account for you"}
          </span>
        )}
      </div>
      
      <Link 
        to="/onboarding"
        className="bg-primary text-white px-3 py-1 rounded text-sm hover:bg-primary/90"
      >
        Resume Setup
      </Link>
    </div>
  );
}

export default OnboardingBanner;
